import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function LaunchXFeature() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">
      {/* Header */}
      <div
        className="relative pb-16"
        style={{ background: "linear-gradient(to bottom, #a0d8ff, #eef7ff)" }}
      >
        <div className="pointer-events-none absolute -top-20 left-10 h-72 w-72 rounded-full bg-white/40 blur-3xl" />
        <div className="pointer-events-none absolute top-24 right-10 h-72 w-72 rounded-full bg-white/30 blur-3xl" />

        <div className="relative z-10 text-center pt-20 px-6">
          <motion.h1
            className="text-3xl md:text-4xl font-semibold tracking-tight"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            🚀 Featured Opportunity
          </motion.h1>

          <motion.p
            className="mt-4 max-w-2xl mx-auto text-gray-700 text-base md:text-lg leading-relaxed"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.05 }}
          >
            We're proud to spotlight one of our top recommended programs.
          </motion.p>
        </div>

        <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-b from-transparent to-white" />
      </div>

      {/* LaunchX Card */}
      <div className="max-w-3xl mx-auto px-6 -mt-10 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-md border border-gray-200 p-8"
        >
          <h2 className="text-xl font-semibold text-gray-900">
            LaunchX Entrepreneurship Program
          </h2>

          <p className="mt-3 text-gray-700 leading-relaxed">
            LaunchX is an immersive summer entrepreneurship program where
            students build real startups, work with experienced mentors,
            and pitch to investors. Participants gain hands-on experience
            in business strategy, product development, and leadership.
          </p>

          <ul className="mt-4 text-sm text-gray-700 space-y-2">
            <li>• Build and launch a real startup</li>
            <li>• Work with experienced founders and mentors</li>
            <li>• Develop leadership and pitching skills</li>
            <li>• Strengthen your college applications</li>
          </ul>

          <a
            href="https://www.launchx.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-6 text-indigo-600 font-semibold hover:text-indigo-800 transition"
          >
            Visit Official Website →
          </a>
        </motion.div>

        {/* Navigate Back Button */}
        <div className="text-center mt-10">
          <button
            onClick={() => navigate("/admissionstoolkit")}
            className="bg-black text-white px-6 py-3 rounded-full text-sm font-semibold hover:opacity-90 transition"
          >
            Navigate to other programs →
          </button>
        </div>
      </div>
    </div>
  );
}